// Maps stake-program custom error codes (src/error.rs) to user-facing messages.

import strings from '../../localization';

const MESSAGES: Record<number, () => string> = {
  6009: () => strings.tokenStaking.errPaused,
  6010: () => strings.tokenStaking.errBelowMinimum,
  6011: () => strings.tokenStaking.errCapExceeded,
  6012: () => strings.tokenStaking.errRewardsUnderfunded,
  6013: () => strings.tokenStaking.errNoPosition,
  6014: () => strings.tokenStaking.errLocked,
  6015: () => strings.tokenStaking.errNothingToClaim,
  6016: () => strings.tokenStaking.errInsufficientRewardVault,
  6017: () => strings.tokenStaking.errExceedsPrincipal,
};

/** Custom code from a simulation or send error, if any. */
export function customErrorCode(err: unknown): number | null {
  const custom = (err as any)?.InstructionError?.[1]?.Custom;
  if (typeof custom === 'number') return custom;
  const text = err instanceof Error ? err.message : typeof err === 'string' ? err : '';
  const match = /custom program error: 0x([0-9a-f]+)/i.exec(text);
  return match ? parseInt(match[1], 16) : null;
}

export function describeError(err: unknown): string {
  const code = customErrorCode(err);
  if (code !== null && MESSAGES[code]) return MESSAGES[code]();
  if (code !== null) return `${strings.tokenStaking.errProgram} (${code})`;
  return err instanceof Error ? err.message : String(err);
}
